module.exports = __webpack_public_path__ + "img/VectorLogo.bd199365.png";